import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const PatchModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_123_17396)">
            <rect
              x="16.3113"
              y="0.310547"
              width="10.3905"
              height="22.6278"
              rx="3"
              transform="rotate(45 16.3113 0.310547)"
              fill="url(#paint0_linear_123_17396)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.8126 7.76352C14.0315 6.98247 12.7652 6.98247 11.9841 7.76352L7.74149 12.0062C6.96044 12.7872 6.96044 14.0535 7.74149 14.8346L9.1557 16.2488C9.93675 17.0299 11.2031 17.0299 11.9841 16.2488L16.2268 12.0062C17.0078 11.2251 17.0078 9.95878 16.2268 9.17773L14.8126 7.76352ZM14.1054 8.47063C13.7149 8.08011 13.0818 8.08011 12.6912 8.47063L8.44859 12.7133C8.05807 13.1038 8.05807 13.737 8.44859 14.1275L9.86281 15.5417C10.2533 15.9322 10.8865 15.9322 11.277 15.5417L15.5197 11.2991C15.9102 10.9085 15.9102 10.2754 15.5197 9.88484L14.1054 8.47063Z"
              fill="#394504"
            />
            <circle
              cx="15.5197"
              cy="5.64175"
              r="1"
              transform="rotate(45 15.5197 5.64175)"
              fill="#394504"
            />
            <circle
              cx="5.62018"
              cy="15.5412"
              r="1"
              transform="rotate(45 5.62018 15.5412)"
              fill="#394504"
            />
            <circle
              cx="18.3481"
              cy="8.47085"
              r="1"
              transform="rotate(45 18.3481 8.47085)"
              fill="#394504"
            />
            <circle
              cx="8.44861"
              cy="18.3703"
              r="1"
              transform="rotate(45 8.44861 18.3703)"
              fill="#394504"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_123_17396"
              x1="21.5066"
              y1="0.310547"
              x2="21.5066"
              y2="22.9383"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4EC623" />
              <stop offset="1" stop-color="#D5F939" />
            </linearGradient>
            <clipPath id="clip0_123_17396">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </SVGIconRender>
  );
};

export default PatchModule;
